import React from 'react';
import PropTypes from "prop-types";
import {CreditCardNumberInputGroup} from "../validation/CreditCardNumberInputGroup";
import {RequiredInputGroup} from "../validation/RequiredInputGroup";
import {CreditCardExpirationInputGroup} from "../validation/CreditCardExpirationInputGroup";
import {CreditCardCvvInputGroup} from "../validation/CreditCardCvvInputGroup";
import "./credit-card-inputs.css";

export class CreditCardInputs extends React.Component {
    constructor(props) {
        super(props);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleNumberBlur = this.handleNumberBlur.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleNameBlur = this.handleNameBlur.bind(this);
        this.handleExpirationChange = this.handleExpirationChange.bind(this);
        this.handleExpirationBlur = this.handleExpirationBlur.bind(this);
        this.handleCvvChange = this.handleCvvChange.bind(this);
        this.handleCvvBlur = this.handleCvvBlur.bind(this);
        this.handleValues = this.handleValues.bind(this);
        this.handleNumberAlertUpdate = this.handleNumberAlertUpdate.bind(this);
        this.handleNameAlertUpdate = this.handleNameAlertUpdate.bind(this);
        this.handleExpirationAlertUpdate = this.handleExpirationAlertUpdate.bind(this);
        this.handleCvvAlertUpdate = this.handleCvvAlertUpdate.bind(this);
        this.handleAlertUpdate = this.handleAlertUpdate.bind(this);
        this.state = {
            card: {
                number: {
                    id: props.card.number.id || "ccnumber",
                    disabled: props.card.number.disabled || false,
                    label: {name: props.card.number.label.name || "Número do cartão"},
                    required: props.card.number.required || true,
                    value: props.card.number.value,
                    title: props.card.number.title || "Input de número do cartão de crédito"
                },
                name: {
                    id: props.card.name.id || "ccname",
                    disabled: props.card.name.disabled || false,
                    label: {name: props.card.name.label.name || "Nome impresso no cartão"},
                    required: props.card.name.required || true,
                    value: props.card.name.value,
                    title: props.card.name.title || "Input de nome do cartão de crédito"
                },
                expiration: {
                    id: props.card.expiration.id || "ccexpiration",
                    disabled: props.card.expiration.disabled || false,
                    label: {name: props.card.expiration.label.name || "Vencimento"},
                    required: props.card.expiration.required || true,
                    value: props.card.expiration.value,
                    title: props.card.expiration.title || "Input de data de vencimento do cartão de crédito",
                    placeholder: "MM/AA"
                },
                cvv: {
                    id: "cccvv",
                    disabled: props.card.cvv.disabled || false,
                    label: {name: props.card.cvv.label.name || "CVV"},
                    required: props.card.cvv.required || true,
                    value: props.card.cvv.value,
                    title: props.card.cvv.title || "Digitos verificadores do cartão de crédito"
                }
            }
        };
    }

    handleNumberChange(value) {
        this.handleValues("number", value, "change");
    }

    handleNameChange(value) {
        this.handleValues("name", value, "change");
    }

    handleExpirationChange(value) {
        this.handleValues("expiration", value, "change");
    }

    handleCvvChange(value) {
        this.handleValues("cvv", value, "change");
    }

    handleNumberBlur(value) {
        this.handleValues("number", value, "blur");
    }

    handleNameBlur(value) {
        this.handleValues("name", value, "blur");
    }

    handleExpirationBlur(value) {
        this.handleValues("expiration", value, "blur");
    }

    handleCvvBlur(value) {
        this.handleValues("cvv", value, "blur");
    }

    handleValues(key, value, type) {
        let state = Object.assign(this.state);
        state.card[key].value = value;
        this.setState(state);

        if (type === "change") {
            this.props.onChange(this.state.card);
        } else if (type === "blur") {
            this.props.onBlur(this.state.card);
        }
    }

    handleNumberAlertUpdate(alert) {
        this.handleAlertUpdate("number", alert);
    }

    handleNameAlertUpdate(alert) {
        this.handleAlertUpdate("name", alert);
    }

    handleExpirationAlertUpdate(alert) {
        this.handleAlertUpdate("expiration", alert);
    }

    handleCvvAlertUpdate(alert) {
        this.handleAlertUpdate("cvv", alert);
    }

    handleAlertUpdate(prop, alert) {
        let alerts = Object.assign(this.props.alerts);
        alerts[prop] = alert;
        this.props.onAlertsUpdate(alerts);
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-xs-6">
                        <CreditCardNumberInputGroup autoFocus={this.props.autoFocus} input={this.state.card.number} alert={this.props.alerts.number}
                                                    onAlertUpdate={this.handleNumberAlertUpdate}
                                                    onChange={this.handleNumberChange} onBlur={this.handleNumberBlur}
                                                    validateOn="blur" flags={this.props.flags}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <RequiredInputGroup input={this.state.card.name} alert={this.props.alerts.name}
                                            onAlertUpdate={this.handleNameAlertUpdate}
                                            onChange={this.handleNameChange} onBlur={this.handleNameBlur}
                                            validateOn="blur"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <CreditCardExpirationInputGroup input={this.state.card.expiration}
                                                        alert={this.props.alerts.expiration}
                                                        onAlertUpdate={this.handleExpirationAlertUpdate}
                                                        onChange={this.handleExpirationChange}
                                                        onBlur={this.handleExpirationBlur} validateOn="blur"/>
                    </div>
                    <div className="col-xs-2">
                        <CreditCardCvvInputGroup input={this.state.card.cvv} alert={this.props.alerts.cvv}
                                                 onAlertUpdate={this.handleCvvAlertUpdate}
                                                 onChange={this.handleCvvChange} onBlur={this.handleCvvBlur}
                                                 validateOn="blur"/>
                    </div>
                </div>
            </div>
        )
    }
}

CreditCardInputs.propTypes = {
    card: PropTypes.shape({
        number: PropTypes.object,
        name: PropTypes.object,
        cvv: PropTypes.object,
        expiration: PropTypes.object,
    }),
    alerts: PropTypes.shape({
        number: PropTypes.object,
        name: PropTypes.object,
        cvv: PropTypes.object,
        expiration: PropTypes.object,
    }),
    onAlertsUpdate: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/input/inputs/CreditCardInputs.js